import { Grid, useMediaQuery } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  closeModalCreateFolder,
  openModalCreateFolder,
  setAMCDetailsPageBreadcrumbsPath,
} from 'store/global/actions';
import {
  checkFirstDeclaration,
  getListPersonneChargeApi,
  getLoadParameters,
  getOrganismesApi,
  getTokenApi,
} from 'store/user/apis';
import { StoreContext } from 'utils/contextStore';
import PAGES from 'routes/pages';
import { useIntl } from 'react-intl';
import { getContractsAMC } from 'store/contract/selectors';
import ActiveStep from './activeStep';
import StepperComponent from './stepper';
import SuccessFailed, { SuccessFailedType } from './successFailed';

export const DeclareFolderProcess = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    declareFolderProcessStepsState,
    organismeListState,
    mandatoryFilesState,
    foldersListState,
    concernedPeopleState,
    successTestState,
    checkFirstDeclareState,
    isLoadingParamsState,
  } = React.useContext(StoreContext);
  const getStep = declareFolderProcessStepsState?.declareFolderProcessSteps;
  const setStep = declareFolderProcessStepsState?.setDeclareFolderProcessSteps;
  const setOrganismeList = organismeListState?.setOrganismeList;
  const organismeList = organismeListState?.organismeList;
  const setMandatoryFiles = mandatoryFilesState?.setMandatoryFiles;
  const setFoldersList = foldersListState?.setFoldersList;
  const setConcernedPeople = concernedPeopleState?.setConcernedPeople;
  const testSuccessProcess = successTestState?.testSuccessProcess;
  const setSuccessProcess = successTestState?.setTestSuccessProcess;
  const setCheckFirstDeclare = checkFirstDeclareState?.setCheckFirstDeclare;
  const setIsLoadingParams = isLoadingParamsState?.setIsLoadingParams;
  const { values, setFieldValue, resetForm } = useFormikContext<any>();
  const [dataSuccessFailed, setDataSuccessFailed] = useState<SuccessFailedType>(
    {
      icon: 'successIcon',
      title: '',
      secondTitle: '',
      actionOne: /* istanbul ignore next */ () => {},
      actionTwo: /* istanbul ignore next */ () => {},
      actionOneTitle: '',
      actionTwoTitle: '',
    },
  );
  const intl = useIntl();
  const token = localStorage.getItem('token');
  const getContracts = useSelector(getContractsAMC);

  React.useEffect(() => {
    getOrganismesApi()
      .then(
        /* istanbul ignore next */ (result) => {
          const dmoOrganisme: any[] = [];
          /* istanbul ignore next */
          if (result.data.data.length > 0) {
            getContracts.map(
              /* istanbul ignore next */ (c: any) => {
                const organisme = result.data.data.find(
                  /* istanbul ignore next */ (r: any) =>
                    r.NUM_POLICE === c.NUM_POLICE,
                );
                organisme && dmoOrganisme.push(organisme);
                return null;
              },
            );
          }
          /* istanbul ignore next */
          setOrganismeList(dmoOrganisme);
        },
      )
      .catch((error) => {});
  }, [getContracts]);

  useEffect(() => {
    /* istanbul ignore next */
    if (values.organisme) {
      setIsLoadingParams(true);
      const id = organismeList.find(
        (o: any) => o.NUM_POLICE === values.organisme,
      )?.id;
      getTokenApi({
        identifiant: id,
        token: token ? token : '',
        username: values.organisme,
      })
        .then((result) => {
          const res = get(result, 'data', {});
          if (!isEmpty(res)) {
            values.token === '' && setFieldValue('token', res?.access_token);
            values.sessionsId === '' &&
              setFieldValue('sessionsId', res?.session_id);
            const payload = {
              NumPolice: res?.numeroPolice?.replace('/', '_'),
              NumIdentification: res?.login,
              idAdherent:
                res?.numeroPolice?.replace('/', '_') +
                'ID' +
                res?.login +
                'CAS',
              token: res?.access_token,
              sessionsId: res?.session_id,
            };
            const payloadCheck = {
              IdUser:
                res?.numeroPolice?.replace('/', '_') +
                'ID' +
                res?.login +
                'CAS',
              token: res?.access_token,
              sessionsId: res?.session_id,
              idAdherent:
                res?.numeroPolice?.replace('/', '_') +
                'ID' +
                res?.login +
                'CAS',
            };
            checkFirstDeclaration(payloadCheck)
              .then((res) => {
                setCheckFirstDeclare(res?.data);
              })
              .catch((err) => {
                setIsLoadingParams(false);
              });

            getLoadParameters(payload)
              .then((result) => {
                setMandatoryFiles(
                  get(result, 'data.ListFichierObligatoire', []),
                );
                setFoldersList(get(result, 'data.ListDossier', []));
                setIsLoadingParams(false);
              })
              .catch((err) => {
                setIsLoadingParams(false);
              });
            getListPersonneChargeApi(payload)
              .then((result) => {
                setConcernedPeople(get(result, 'data', []));
              })
              .catch((err) => {});
          }
        })
        .catch((error) => {
          setIsLoadingParams(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organismeList, values.organisme]);

  /* istanbul ignore next */
  useEffect(() => {
    if (testSuccessProcess) {
      setDataSuccessFailed({
        icon: 'successIcon',
        title: intl.formatMessage({ id: 'dmo.success.title' }),
        secondTitle: `${intl.formatMessage({
          id: 'dmo.success.message.part1',
        })} ${testSuccessProcess?.data} ${intl.formatMessage({
          id: 'dmo.success.message.part2',
        })}`,
        actionOne: () => {
          dispatch(closeModalCreateFolder());
          setSuccessProcess(null);
          setCheckFirstDeclare(null);
          setStep(0);
          dispatch(
            setAMCDetailsPageBreadcrumbsPath([
              { name: 'amc', route: PAGES.AMC_DASHBOARD },
              { name: 'suiviDesDemandes' },
            ]),
          );
          history.push(PAGES.AMC_DETAILS);
        },
        actionTwo: () => {
          dispatch(closeModalCreateFolder());
          setSuccessProcess(null);
          setCheckFirstDeclare(null);
          resetForm();
          setStep(0);
        },
        actionOneTitle: intl.formatMessage({
          id: 'amc_details.requests_follow_up',
        }),
        actionTwoTitle: intl.formatMessage({ id: 'dmo.success.back.home' }),
      });
    } else {
      setDataSuccessFailed({
        icon: 'errorIcon',
        title: intl.formatMessage({ id: 'pac.error' }),
        secondTitle: '',
        actionOne: () => {
          dispatch(closeModalCreateFolder());
          dispatch(openModalCreateFolder());
          setSuccessProcess(null);
          setStep(0);
        },
        actionTwo: () => {
          dispatch(closeModalCreateFolder());
          setSuccessProcess(null);
          setStep(0);
        },
        actionOneTitle: intl.formatMessage({
          id: 'auth_by_contract_failed.next_label',
        }),
        actionTwoTitle: intl.formatMessage({ id: 'dmo.success.back.home' }),
      });
    }
  }, [
    testSuccessProcess,
    dispatch,
    history,
    setSuccessProcess,
    setStep,
    resetForm,
    setCheckFirstDeclare,
    organismeList,
    values.organisme,
    intl,
  ]);
  const isNotMobile = useMediaQuery('(min-width:960px)');
  return (
    <>
      {testSuccessProcess === null ? (
        <Grid container>
          {isNotMobile && (
            <Grid md={4} item>
              <StepperComponent
                activeStep={getStep}
                steps={[
                  intl.formatMessage({ id: 'dmo.step.1' }),
                  intl.formatMessage({ id: 'dmo.step.2' }),
                  intl.formatMessage({ id: 'dmo.step.3' }),
                  intl.formatMessage({ id: 'dmo.step.4' }),
                  intl.formatMessage({ id: 'dmo.step.5' }),
                  intl.formatMessage({ id: 'dmo.step.6' }),
                ]}
              />
            </Grid>
          )}

          <Grid item md={8} xs={12} style={{ padding: '24px' }}>
            <ActiveStep activeStep={getStep} />
          </Grid>
        </Grid>
      ) : (
        <SuccessFailed
          icon={dataSuccessFailed.icon}
          title={dataSuccessFailed.title}
          secondTitle={dataSuccessFailed.secondTitle}
          actionOne={dataSuccessFailed.actionOne}
          actionTwo={dataSuccessFailed.actionTwo}
          actionOneTitle={dataSuccessFailed.actionOneTitle}
          actionTwoTitle={dataSuccessFailed.actionTwoTitle}
        />
      )}
    </>
  );
};
